import {useContext} from 'react'
import {SupplierMappingDetails} from '../../context'
import SupplierMappingTableActionsMenu from '../actions-menu/SupplierMappingDetailsTableActionsMenu'

const SupplierMappingTableRow = ({row, actionOverlay, checkBoxComponent}: any) => {
  const {hasWritePermission} = useContext(SupplierMappingDetails)

  return (
    <tr>
      {checkBoxComponent && <td>{checkBoxComponent(row)}</td>}
      <td>{row['sku']}</td>
      <td>{row['productName']}</td>
      <td>{row['brands']}</td>
      {hasWritePermission && actionOverlay(SupplierMappingTableActionsMenu)}
    </tr>
  )
}

export default SupplierMappingTableRow
